import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header.component';
import { RestoreidHeaderComponent } from './restoreid-header/restoreid-header.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { GeonetworkToolService } from './header.service';
import { MatDividerModule } from '@angular/material/divider';
import { MenuBarModule } from "../menu-bar/menu-bar.module";
import { TopBarModule } from "../top-bar/top-bar.module";

@NgModule({
  declarations: [
    HeaderComponent,
    RestoreidHeaderComponent,
  ],
  imports: [
    CommonModule,
    MatDividerModule,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MenuBarModule,
    TopBarModule
],
  exports: [
    HeaderComponent,
    RestoreidHeaderComponent,
  ],
  providers: [
    GeonetworkToolService
  ]
})
export class HeaderModule { }
